import { combineReducers } from 'redux';

import loading from 'modules/global/reducers/generic.loading';

import * as actions from '../../actionTypes';

export default combineReducers({
  exporting: loading(actions.AUDIT_STATISTICS_EXPORT_REQUEST)
});
